import React, { useState, useRef } from "react";
import Photo from "../../img/png/foto.png";
import { sendContactApi } from "../../api/contactApi.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import "./Contact.css";

export default function Contact() {
  let language = localStorage.getItem("language");

  let errorRef = useRef(null);
  let correctRef = useRef(null);

  const [dataForm, setDataForm] = useState({
    name: "",
    lastName: "",
    email: "",
    reason: "",
  });

  function sendData(e) {
    e.preventDefault();
    if (
      !dataForm.name ||
      !dataForm.lastName ||
      !dataForm.email ||
      !dataForm.reason
    ) {
      correctRef.current.style.display = "none";
      errorRef.current.style.animation = "appear .5s";
      setTimeout(() => {
        errorRef.current.style.display = "block";
      }, 500);
    } else {
      errorRef.current.style.display = "none";
      sendContactApi(dataForm);
      correctRef.current.style.animation = "appear .5s";
      setTimeout(() => {
        correctRef.current.style.display = "block";
      }, 500);
    }
  }

  function setData(e) {
    setDataForm({ ...dataForm, [e.target.name]: e.target.value });
  }

  return (
    <>
      <div className="separate"></div>
      <div className="contact-div">
        <div className="contact-dialog">
          <h2>
            {language === "español" || !language
              ? "¿Quieres contactarme?"
              : "Do you want contact me?"}
          </h2>
          <div className="contact-dialog__info">
            <img
              src={Photo}
              alt="Yojhan Atuesta"
              className="contact-dialog__photo"
            />
            <div>
              <p>YOJHAN ATUESTA</p>
              <p>
                {language === "español" || !language
                  ? "Desarrollador de software"
                  : "Software developer"}
              </p>
            </div>
            <div className="contact-dialog__data">
              <p>
                <FontAwesomeIcon icon={faPhone} /> aatuesta00@hotmail.com
              </p>
              <p>
                <FontAwesomeIcon icon={faEnvelope} /> (+57) 3046377855
              </p>
            </div>
          </div>
        </div>
        <div className="contact">
          <p>
            {language === "español" || !language
              ? "Envíame un mensaje"
              : "Send me a message"}
          </p>
          <form className="contact-form" onChange={setData}>
            <input
              name="name"
              type="text"
              placeholder={
                language === "español" || !language ? "Nombres" : "Name"
              }
            />
            <input
              name="lastName"
              type="text"
              placeholder={
                language === "español" || !language ? "Apellidos" : "Lastname"
              }
            />
            <input
              name="phone"
              type="text"
              placeholder={
                language === "español" || !language ? "Teléfono" : "Phone"
              }
            />
            <input
              name="email"
              type="email"
              placeholder={
                language === "español" || !language
                  ? "Correo electrónico"
                  : "Email"
              }
            />
            <textarea
              name="reason"
              type="text"
              placeholder={
                language === "español" || !language
                  ? "¿Por qué me contactas?"
                  : "Reason of contact"
              }
            />
            <button onClick={sendData}>
              {language === "español" || !language ? "ENVIAR" : "SEND"}
            </button>
            <p ref={errorRef} style={{ display: "none" }} className="error">
              {language === "español" || !language
                ? "Los datos son obligatorios."
                : "The data is required."}
            </p>
            <p ref={correctRef} style={{ display: "none" }} className="correct">
              {language === "español" || !language
                ? "Datos enviados correctamente, pronto me comunicaré con usted."
                : "Data sended, soon i will contact with you."}
            </p>
          </form>
        </div>
      </div>
    </>
  );
}
